// import React from 'react';
// import { BrowserRouter as BrowserRouterAlias, Route, Routes, Navigate } from 'react-router-dom';
// import LoginPage from './pages/auth/LoginPage';
// import ForgotPassword from './pages/auth/ForgotPassword';
// import ResetPassword from './pages/auth/ResetPassword';
// import Sidebar from './components/Sidebar';
// import Dashboard from './pages/AdminPanel/dashboard';
// // import { useAuth } from "./context/UserContext"; // 
// import Header from './pages/steperform/Header';
// import ProtectedRoutes from './protectedRoutes/ProtectedRoutes';
// import { Discounts } from './pages/AdminPanel/discounts/Discounts';
// // import { Plans } from './pages/AdminPanel/plans/Plans';
// import { Premiums } from './pages/AdminPanel/dashboard/premiums/Premiums';
// import { Quotes } from './pages/AdminPanel/quote-history/Quotes';
// import QuoteForm from './pages/quote-form/QuoteForm';
// import StepperForm from './component/StepperForm';


// export const ALLrouter =()=> {
//     // Simulating authentication status
//     // const { currentUser } = useAuth(); // Assume this hook provides the `currentUser`
  
//     return (
//       <BrowserRouterAlias>
//       <Routes>
//         {/* Public Routes */}
//         {/* <Route path="/login" element={<LoginPage />} />
//         <Route path="/forgot-password" element={<ForgotPassword />} />
//         <Route path="/reset-password" element={<ResetPassword />} />
//         <Route path="/quote" element={<Header />} />
//         <Route path="/quote-version" element={<QuoteForm />} />

//         {/* Protected Routes */}
//         {/* <Route
//           path="/*"
//           element={
//             <ProtectedRoutes>
//               <div className="flex">
//                 <Sidebar /> */}
//                 {/* <div className="flex-grow bg-[#F9F8F5]"> */}
//                   {/* <Routes> */}
//                     {/* <Route path="/dashboard" element={<Dashboard />} />
//                     <Route path="/plans" element={<Plans />} />
//                     <Route path="/premiums" element={<Premiums/>} />
//                     <Route path="/discounts" element={<Discounts/>} />
//                     <Route path="/quote-history" element={<Quotes/>} /> */}
//                     {/* <Route path="/logout" element={<div>Logout Page</div>} /> */}
//                   {/* </Routes> */}
//                 {/* </div> */}
//               {/* </div> */}
//             {/* </ProtectedRoutes> */}
//           {/* } */}
//         {/* /> */}
//       </Routes>
//       <StepperForm />
//     </BrowserRouterAlias>
//     );
//   }
  
//   export default ALLrouter;
  


import React from 'react';
import { BrowserRouter as BrowserRouterAlias, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from './pages/auth/LoginPage';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/AdminPanel/dashboard';
// import { useAuth } from "./context/UserContext"; // 
// import Header from './pages/steperform/Header';
import ProtectedRoutes from './protectedRoutes/ProtectedRoutes';
import { Discounts } from './pages/AdminPanel/discounts/Discounts';
import PlansHistory, { Plans } from './pages/AdminPanel/plans/PlansHistory';
import { Premiums } from './pages/AdminPanel/dashboard/premiums/Premiums';
import { Quotes } from './pages/AdminPanel/quote-history/Quotes';
import QuoteForm from './pages/quote-form/QuoteForm';
import StepperForm from './component/StepperForm';
import ViewQuote from './pages/AdminPanel/quote-history/ViewQuote';
import { CreatePlanModule } from './pages/AdminPanel/plans/CreatePlanModule';
import { UpdatePlanModule } from './pages/AdminPanel/plans/UpdatePlanModule';


export const ALLrouter =()=> {
    // Simulating authentication status
    // const { currentUser } = useAuth(); // Assume this hook provides the currentUser
  
    return (
      <BrowserRouterAlias>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* <Route path="/quote" element={<Header />} /> */}
        {/* <Route path="/quote-version" element={<QuoteForm />} /> */}
        <Route path="/get-quote" element={<QuoteForm />} />


        {/* Protected Routes */}
        <Route
          path="/*"
          element={
            <ProtectedRoutes>
            <div className="lg:flex h-screen">
              <div className='lg:w-1/6 lg:mb-0 mb-10'>
                <Sidebar />
              </div>
                <div className="lg:w-5/6 bg-[#F9F8F5] overflow-y-auto">
                  <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/plans" element={<PlansHistory/>} />
                    {/* <Route path="/premiums" element={<Premiums/>} />
                    <Route path="/discounts" element={<Discounts/>} /> */}
                    <Route path="/quote-history" element={<Quotes/>} />
                    <Route path="/create-module" element={<CreatePlanModule/>} />
                    <Route path="/update-module/:id" element={<UpdatePlanModule/>} />
                    <Route path="/view-quote/:id" element={<ViewQuote/>} />
                    {/* <Route path="/logout" element={<div>Logout Page</div>} /> */}
                  </Routes>
                </div>
              </div>
            </ProtectedRoutes>
          }
        />
      </Routes>
    </BrowserRouterAlias>
    );
  }
  
  export default ALLrouter;